const type = "en-NG";

const format = {
  style: "currency",
  currency: "NGN",
};

export const currencyFormat = (price) =>
  Number(price).toLocaleString(type, format);
